/* eslint-disable react/jsx-curly-newline */
/* eslint-disable implicit-arrow-linebreak */
import React from 'react';
import { TableColumn } from 'react-data-table-component';
import { DefaultTable } from 'src/components';
import { useNavigate } from 'react-router-dom';

// import { mockReports } from './mocks/reports.mock';

export type ReportsType = {
  id: string;
  name: string;
  description: string;
  path: string;
};

export const currentReports: ReportsType[] = [
  {
    id: '1',
    name: 'Worker Enrolled benefits',
    description: 'Summary of all enrolled benefits for the employee.',
    path: 'worker-enrolled-benefits',
  },
  {
    id: '2',
    name: 'AON Report',
    description:
      'Summary of all enrolled benefits for the employee. (Medical, Dental, Vision and Life Insurance coverage)',
    path: 'worker-enrolled-benefits-old',
  },
  {
    id: '2',
    name: 'Eligible but Not Elected Plans by Employee',
    description:
      'Eligible but Not Elected Plans by Employee - Summary of all benefits that the employee is eligible for but has not elected.',
    path: 'worker-enrolled-benefits-notenrolled',
  },
];

const columns: TableColumn<ReportsType>[] = [
  {
    name: 'Report Name',
    selector: (row: ReportsType) => row.name || '',
    sortable: true,
  },
  {
    name: 'Description',
    selector: (row: ReportsType) => row.description || '',
    sortable: true,
  },
];

export const ReportsTable: React.FC = () => {
  const navigate = useNavigate();

  return (
    <DefaultTable columns={columns} data={currentReports} onRowClicked={row => navigate(row.path, { replace: true })} />
  );
};
